import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Detail from "./routes/Detail";
import Home from "./routes/Home"

function App() {
  return (
  <Router> {/* 이 안에 들어가는 것들은 유저에게 보여주고 싶은 것들 */}
    <Routes> {/* 한번에 하나만 렌더링 시키기 위함 */}
      <Route path="/movie/:id" element={<Detail />} />
      <Route path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
    </Routes>
  </Router>
  );
}
export default App;

//router를 render하는 곳
//router는 URL을 보고있는 component임.
//Link : 새로고침 없이도 다른 페이지로 가게 해주는 것
//npm i gh-pages : 결과물을 github pages에 업로드 할 수 있게 해주는 나이스한 패키지
//npm run build : 우리 웹사이트의 production ready code를 생성하게 됨
//production ready : 코드가 압축되고 모든게 최적화된다는 의미